import React, { useState, useEffect } from 'react';
import Auth from '../../../components/Auth';
import Login from '../../../components/Login';
import ResetByAnswer from '../../../components/ResetByAnswer';
import ResetByOTP from '../../../components/ResetByOTP';
import ResetByMail from '../../../components/ResetByMail';
import Spinner from '../../../components/Spinner';
import dayjs from 'dayjs';

const HomeView = ({
  location,
  currentUser: data = {},
  getCurrentUser = () => {},
  sendOtp = () => {},
  resetByAnswer = () => {},
  resetByOtp = () => {},
  getConfiguration = () => {},
}) => {
  const [type, setType] = useState(''); // PASSWORD_TYPE_2 | PASSWORD_TYPE_3
  const [method, setMethod] = useState(''); // METHOD_SECRET_QUESTION | METHOD_OTP_VIA_PHONE | METHOD_OTP_VIA_EMAIL
  const [isAvailable, setIsAvailable] = useState(false);

  // useEffect(() => {
  //   if (!data.loading) {
  //     getConfiguration(method, type)
  //     const systemTime = dayjs.unix(data.userStatusInfos.system_time);
  //     const bindTime = dayjs.unix(data.userStatusInfos.bind_time);
  //     const diff = systemTime.diff(bindTime, 'day');
  //     setIsAvailable(diff >= 30);
  //     if (!!data.userStatusInfos.remain_many_request_wait_time) {
  //       setType(2);
  //   }
  // }, [data.loading]);

  const handleClickType = (type, method, e) => {
    e.preventDefault();
    setType(type);
    setMethod(method);
    getConfiguration(method, type)
  };

  const handleBack = () => {
    setType('');
    setMethod('');
  }

  return data.loading ? <Spinner/> : (
    <>
      {data.login ? (
        <div className="box">
          <div className="box__header">
            KHÔI PHỤC MẬT KHẨU {type == 'PASSWORD_TYPE_2' ? 'CẤP 2' : type == 'PASSWORD_TYPE_3' ? 'CẤP 3' : ''}
          </div>
          <div className="box__body">
            <Auth username={data.user.nickname}/>
            {!type && (
              <div className="box__body--wrap-type">
                <div className="box__body--actions box__body--type">
                  <a href="#"
                      className={`${type == 'PASSWORD_TYPE_2' ? 'active' : ''}`}
                      onClick={e => handleClickType('PASSWORD_TYPE_2', 'METHOD_SECRET_QUESTION', e)}
                    >
                      Khôi phục mật khẩu cấp 2
                    </a>
                    <a href="#"
                      className={`${type == 'PASSWORD_TYPE_3' ? 'active' : ''}`}
                      onClick={e => handleClickType('PASSWORD_TYPE_3', 'METHOD_OTP_VIA_PHONE', e)}
                    >
                      Khôi phục mật khẩu cấp 3
                    </a>
                </div>
              </div>
            )}
              {type === 'PASSWORD_TYPE_2' && (
                <>
                <div className="box__body--actions">
                  <a href="#"
                    className={`${type == 'PASSWORD_TYPE_2' && method == 'METHOD_SECRET_QUESTION' ? 'active' : ''}`}
                    onClick={e => handleClickType('PASSWORD_TYPE_2', 'METHOD_SECRET_QUESTION', e)}
                  >
                    Bằng câu hỏi bí mật
                  </a>
                  <a href="#"
                    className={`${type == 'PASSWORD_TYPE_2' && method == 'METHOD_OTP_VIA_PHONE' ? 'active' : ''}`}
                    onClick={e => handleClickType('PASSWORD_TYPE_2', 'METHOD_OTP_VIA_PHONE', e)}
                  >
                    Bằng Số điện thoại
                  </a>
                  <a href="#"
                    className={`${type == 'PASSWORD_TYPE_2' && method == 'METHOD_OTP_VIA_EMAIL' ? 'active' : ''}`}
                    onClick={e => handleClickType('PASSWORD_TYPE_2', 'METHOD_OTP_VIA_EMAIL', e)}
                  >
                    Bằng Email
                  </a>
                </div>
                {type == 'PASSWORD_TYPE_2' && method == 'METHOD_SECRET_QUESTION' && !data?.isConfigurationing  && (
                  data.configuration.secret_question_method?.question ? (
                    <ResetByAnswer
                      data={data}
                      resetByAnswer={resetByAnswer}
                      handleBack={handleBack}
                      type={type}
                    />
                    ) : (
                      <div className="box__body--note">
                        Tài khoản chưa khởi tạo mật khẩu 2. <br/>Hãy truy cập game <a href="#">FIFA Online 4</a> khởi tạo mật khẩu 2 để bảo vệ tài khoản.
                      </div>
                    )
                )}
                {type == 'PASSWORD_TYPE_2' && method == 'METHOD_OTP_VIA_PHONE' && !data?.isConfigurationing && (
                  <>
                    {data.configuration.phone_method?.phone_number ? (
                      <>
                        <ResetByOTP
                          data={data}
                          method={method}
                          type={type}
                          sendOtp={sendOtp}
                          resetByOtp={resetByOtp}
                          handleBack={handleBack}
                        />
                      </>
                    ) : (
                      <div className="box__body--note">
                        {data?.errorCodeConfiguration == 'NoVerifiedPhoneError' && (
                          <>
                            Tài khoản Garena chưa đăng ký số điện thoại xác thực, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'NoPasswordType2Error' && (
                          <>
                            Tài khoản chưa khởi tạo mật khẩu 2. <br/>Hãy truy cập game <a href="#">FIFA Online 4</a> khởi tạo mật khẩu cấp 2 để bảo vệ tài khoản.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'PhoneNotSatisfiedError' && (
                          <>
                            Số điện thoại xác thực chưa đủ điều kiện khởi tạo mật khẩu cấp 2, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/gui-yeu-cau/259-119/">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        <div>
                          <a href="#" className="btn-back btn-hover-scale" onClick={e => {
                            e.preventDefault()
                            handleBack()
                          }}>Quay lại</a>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {type == 'PASSWORD_TYPE_2' && method == 'METHOD_OTP_VIA_EMAIL' && !data?.isConfigurationing && (
                  <>
                    {data.configuration.email_method?.email ? (
                      <>
                        <ResetByMail
                          data={data}
                          method={method}
                          type={type}
                          sendOtp={sendOtp}
                          resetByOtp={resetByOtp}
                          handleBack={handleBack}
                        />
                      </>
                    ) : (
                      <div className="box__body--note">
                        {data?.errorCodeConfiguration == 'NoPasswordType2Error' && (
                          <>
                            Tài khoản chưa khởi tạo mật khẩu 2. <br/>Hãy truy cập game <a href="#">FIFA Online 4</a> khởi tạo mật khẩu cấp 2 để bảo vệ tài khoản.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'NoUserEmail' && (
                          <>
                            {/* Tài khoản chưa xác thực email. <br/>Hãy truy cập game <a href="https://hotro.garena.vn/gui-yeu-cau/259-119/">FIFA Online 4</a> khởi tạo mật khẩu cấp 2 để bảo vệ tài khoản. */}
                            Tài khoản Garena chưa đăng ký email xác thực, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.

                          </>
                        )}
                        {data?.errorCodeConfiguration == 'EmailNotVerifiedError' && (
                          <>
                            Tài khoản Garena chưa xác thực email, bạn vui lòng xác thực mail <a href="https://account.garena.com/" target="_blank">tại đây</a> và thử lại. Nếu email không còn sử dụng, bạn gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'EmailNotSatisfiedError' && (
                          <>
                            {/* Email xác thực chưa đủ điều kiện khởi tạo mật khẩu cấp 2, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/gui-yeu-cau/259-119/">tại đây</a> để được tư vấn hỗ trợ. */}
                            Email xác thực chưa đủ điều kiện khởi tạo mật khẩu 2, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}

                        <div>
                          <a href="#" className="btn-back btn-hover-scale" onClick={e => {
                            e.preventDefault()
                            handleBack()
                          }}>Quay lại</a>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
              )}

              {type === 'PASSWORD_TYPE_3' && (
                <>
                <div className="box__body--actions">
                  <a href="#"
                    className={`${type == 'PASSWORD_TYPE_3' && method == 'METHOD_OTP_VIA_PHONE' ? 'active' : ''}`}
                    onClick={e => handleClickType('PASSWORD_TYPE_3', 'METHOD_OTP_VIA_PHONE', e)}
                  >
                    Bằng Số điện thoại
                  </a>
                  <a href="#"
                    className={`${type == 'PASSWORD_TYPE_3' && method == 'METHOD_OTP_VIA_EMAIL' ? 'active' : ''}`}
                    onClick={e => handleClickType('PASSWORD_TYPE_3', 'METHOD_OTP_VIA_EMAIL', e)}
                  >
                    Bằng Email
                  </a>
                </div>
                {type == 'PASSWORD_TYPE_3' && method == 'METHOD_OTP_VIA_PHONE' && !data?.isConfigurationing && (
                  <>
                    {data.configuration.phone_method?.phone_number ? (
                      <>
                        <ResetByOTP
                          data={data}
                          method={method}
                          type={type}
                          sendOtp={sendOtp}
                          resetByOtp={resetByOtp}
                          handleBack={handleBack}
                        />
                      </>
                    ) : (
                      <div className="box__body--note">
                        {data?.errorCodeConfiguration == 'NoVerifiedPhoneError' && (
                          <>
                            Tài khoản Garena chưa đăng ký số điện thoại xác thực, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'NoPasswordType3Error' && (
                          <>
                            Tài khoản chưa khởi tạo mật khẩu 3. <br/>Hãy truy cập game <a href="#">FIFA Online 4</a> khởi tạo mật khẩu cấp 3 để bảo vệ tài khoản.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'PhoneNotSatisfiedError' && (
                          <>
                            Số điện thoại xác thực chưa đủ điều kiện khởi tạo mật khẩu cấp 3, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/gui-yeu-cau/575-379/">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        <div>
                          <a href="#" className="btn-back btn-hover-scale" onClick={e => {
                            e.preventDefault()
                            handleBack()
                          }}>Quay lại</a>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {type == 'PASSWORD_TYPE_3' && method == 'METHOD_OTP_VIA_EMAIL' && !data?.isConfigurationing && (
                  <>
                    {data.configuration.email_method?.email ? (
                      <>
                        <ResetByMail
                          data={data}
                          method={method}
                          type={type}
                          sendOtp={sendOtp}
                          resetByOtp={resetByOtp}
                          handleBack={handleBack}
                        />
                      </>
                    ) : (
                      <div className="box__body--note">
                        {data?.errorCodeConfiguration == 'NoPasswordType3Error' && (
                          <>
                            Tài khoản chưa khởi tạo mật khẩu 3. <br/>Hãy truy cập game <a href="#">FIFA Online 4</a> khởi tạo mật khẩu cấp 3 để bảo vệ tài khoản.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'NoUserEmail' && (
                          <>
                            {/* Tài khoản chưa xác thực email. <br/>Hãy truy cập game <a href="https://hotro.garena.vn/gui-yeu-cau/259-119/">FIFA Online 4</a> khởi tạo mật khẩu cấp 3 để bảo vệ tài khoản. */}
                            Tài khoản Garena chưa đăng ký email xác thực, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'EmailNotVerifiedError' && (
                          <>
                            Tài khoản Garena chưa xác thực email, bạn vui lòng xác thực mail <a href="https://account.garena.com/" target="_blank">tại đây</a> và thử lại. Nếu email không còn sử dụng, bạn gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        {data?.errorCodeConfiguration == 'EmailNotSatisfiedError' && (
                          <>
                            {/* Email xác thực chưa đủ điều kiện khởi tạo mật khẩu cấp 2, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/gui-yeu-cau/259-119/">tại đây</a> để được tư vấn hỗ trợ. */}
                            Email xác thực chưa đủ điều kiện khởi tạo mật khẩu 3, bạn vui lòng gửi phiếu yêu cầu <a href="https://hotro.garena.vn/ho-tro/fifa-online-4-8/" target="_blank">tại đây</a> để được tư vấn hỗ trợ.
                          </>
                        )}
                        <div>
                          <a href="#" className="btn-back btn-hover-scale" onClick={e => {
                            e.preventDefault()
                            handleBack()
                          }}>Quay lại</a>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
              )}
          </div>
        </div>
      ) : (
        <Login/>
      )}
    </>
  );
};

export default HomeView;
